export default __webpack_public_path__ + "static/media/ispo-bg.15d37850.jpg";